import './config/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from 'components/App';

import store from 'config/store';

// eslint-disable-next-line import/no-unresolved
import 'assets/styles/tailwind-autogenerated.css';

const app = document.getElementById('root');

// Honeybadger Setup
const honeyBadgerConfig = {
  apiKey: process.env.REACT_APP_HONEY_BADGER_API_KEY,
  environment: process.env.REACT_APP_ENV,
  reportData: process.env.NODE_ENV !== 'development',
  maxErrors: 20,
};
const honeyBadgerContext = {
  api_user_key: process.env.REACT_APP_X_API_KEY,
};
const ignoredErrors = ['ChunkLoadError', 'window.onunhandledrejection', 'DataCloneError'];
// Errors thrown by scripts that browser extensions inject into the page
const extensionUrlPattern = /^(chrome|moz|safari(-web)?|ms-browser)-extension:\/\//;

const honeybadger = Honeybadger.configure(honeyBadgerConfig);
honeybadger.setContext(honeyBadgerContext);

Honeybadger.beforeNotify((notice) => {
  if (ignoredErrors.includes(notice.name)) return false;
  const topFrame = (notice.backtrace && notice.backtrace[0]) || {};
  if (extensionUrlPattern.test(topFrame.file || '')) return false;
  return true;
});

const AppWrapper = process.env.REACT_APP_SIGN_IN_GOOGLE_CLIENT_ID ? (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_SIGN_IN_GOOGLE_CLIENT_ID}>
    <App store={store} />
  </GoogleOAuthProvider>
) : <App store={store} />;

ReactDOM.render(
  <HoneybadgerErrorBoundary honeybadger={honeybadger}>
    {AppWrapper}
  </HoneybadgerErrorBoundary>,
  app,
);
